<script setup>
import { computed } from 'vue';
import { useMessageContext } from '../../provider.js';

import MessageFormatter from 'shared/helpers/MessageFormatter.js';
import { MESSAGE_VARIANTS } from '../../constants';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
});

const { variant } = useMessageContext();

const formattedContent = computed(() => {
  if (variant.value === MESSAGE_VARIANTS.ACTIVITY) {
    return props.content;
  }

  return new MessageFormatter(props.content).formattedMessage;
});
</script>

<template>
  <span
    v-dompurify-html="formattedContent"
    class="prose prose-bubble text-current [&_*]:text-current"
    :class="{ 'bot-prose-bubble': variant === MESSAGE_VARIANTS.BOT }"
  />
</template>

<style scoped>
.bot-prose-bubble,
.bot-prose-bubble :deep(*) {
  color: #334155 !important;
}
</style>
